export const _app_name = "Gridaboard v2";
export const _lib_name = "NeoLAB Ncode Print Library";
export const _version = "2.0";